import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import { useEffect } from "react";
import swal from "sweetalert";
import { makeGetRequest, makePostRequest } from "../../../utils/utils";
import dayjs from "dayjs";
import { Formik, Form } from "formik";
import * as Yup from "yup";

// For Date Picker
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
// End

// For Tab
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// End

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function SendInvoice() {
  const navigate = useNavigate();

  // For Tab
  const [value2, setValue2] = React.useState(0);

  const handleChange2 = (event, newValue) => {
    setValue2(newValue);
  };
  // End

  const [ownersList, setOwnersList] = React.useState([]);
  const [apartmentList, setApartmentList] = React.useState([]);
  const [q, setQ] = React.useState("");
  const [selectedOwner, setSelectedOwner] = React.useState("");
  const [selectedApartment, setSelectedApartment] = React.useState("");

  // const [ownerData, setOwnerData] = React.useState({});

  const [invoiceNo, setInvoiceNo] = React.useState(0);
  const [invoice_date, setInvoiceDate] = React.useState(dayjs(new Date()));
  const [due_date, setDueDate] = React.useState(dayjs(new Date()));
  const [subject, setSubject] = React.useState("");

  const [billto, setBillTo] = React.useState("");
  const [wing] = React.useState("");
  const [apartmentNo, setApartmentNo] = React.useState("");
  const [contactNo, setContactNo] = React.useState("");
  const [emailId, setEmailId] = React.useState("");

  const [note, setNote] = React.useState("");
  const [cgst] = React.useState(10);
  const [sgst] = React.useState(10);
  const [cgstAmt, setCgstAmt] = React.useState(0);
  const [sgstAmt, setSgstAmt] = React.useState(0);
  const [subTotal, setSubTotal] = React.useState(0);
  const [advanceReceived] = React.useState(100);
  const [totalPayable, setTotalPayable] = React.useState(0);
  const [maintenenceIdList, setMaintenenceIdList] = React.useState([]);
  const [maintenenceList, setMaintenenceList] = React.useState([]);
  // const [taxList, setTaxList] = React.useState([]);

  const Validation_Schema = Yup.object().shape({
    selectedOwner: Yup.string().required("Required"),
    subject: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
    note: Yup.string()
      .required("Required")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Numbers not allowed!!"
      ),
  });

  var formikInitials = {
    subject: subject,
    note: note,
  };

  async function OwnerListing() {
    let bodyFormData = {};
    // alert(q)
    makeGetRequest("resident/getall", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log("Owner Data");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setOwnersList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function MaintenenceListing() {
    let bodyFormData = {};

    makeGetRequest("maintenence/getall", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log("Maintenence Data");
          console.log(response.data.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          setMaintenenceList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const [value, setValue] = React.useState(0);
  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  const handlechangeOwner = (e) => {
    setSelectedOwner(e.target.value);
    console.log("Building Data ", e);

    makeGetRequest("resident/getalldetails/" + e.target.value, "")
      .then((response) => {
        if (response.status == "201") {
          console.log("Owner Obj");
          console.log(response.data);
          // setlength(response.data.data.rowCount);
          const data = response.data.data;
          // setOwnerData(data);
          setApartmentList(response.data.apartmentList);
          setBillTo(data.user_obj.first_name + " " + data.user_obj.last_name);
          setEmailId(data.user_obj.email_id);
          setContactNo(data.user_obj.contact_no);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
    // setOwnerData()
  };

  const handlechangeApartment = (e) => {
    var selectedApartment = e.target.value;
    setSelectedApartment(e.target.value);
    var total = 0;
    for (var i = 0; i < apartmentList.length; i++) {
      if (apartmentList[i].apartment_id == selectedApartment) {
        var apartmentObj = apartmentList[i];
        console.log("selected Apartment ", apartmentObj);
        setApartmentNo(apartmentObj.uniq_apt_name);
        for (var j = 0; j < maintenenceList.length; j++) {
          maintenenceIdList[j] = maintenenceList[j].maintenence_id;
          console.log("Before total ", total);
          total = total + maintenenceList[j].amount;
          console.log("After total ", total);
        }
        setMaintenenceIdList(maintenenceIdList);
        console.log("maintenenceList ", maintenenceIdList);

        setSubTotal(total);

        setCgstAmt((total * cgst) / 100);
        setSgstAmt((total * sgst) / 100);
        setTotalPayable(total - advanceReceived + cgstAmt + sgstAmt);
        console.log("Subtotal ", subTotal);
      }
    }
  };

  // For Date Picker
  const [value1, setValue1] = React.useState(new dayjs());

  const handleInvoiceDate = (newValue) => {
    setInvoiceDate(newValue);
    // setDueDate(invoice_date.add(1,'month'));
  };

  // const [value2, setValue2] = React.useState(dayjs('2014-08-18T21:11:54'));
  const handleDueDate = (newValue) => {
    setDueDate(newValue);
  };
  // End

  // const handleInvoiceDate = (e) => {
  //   console.log("Invoice Date", e.target.value);
  //   setInvoiceDate(e.target.value);
  // };

  // const handleDueDate = (e) => {
  //   console.log("Due Date", e.target.value);
  //   setDueDate(e.target.value);
  // };

  const deleteField = () => {
    alert("No click delete this Field");
  };

  async function saveInvoice() {
    alert("In Save Invoice");
    let inputdata = {
      invoice_date: invoice_date,
      due_date: due_date,
      resident_id: selectedOwner,
      maintenenceid_list: maintenenceIdList,
      total_payment: subTotal,
      advance_received: advanceReceived,
      past_due: 0,
      cgst: cgst,
      sgst: sgst,
    };
    makePostRequest("invoice/insert", inputdata)
      .then((response) => {
        if (response.data.data !== undefined) {
          swal("Success", "Invoice Created Successully....", "success", {
            timer: 1000,
            buttons: false,
          });
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function getMaxInvoiceId() {
    console.log("In Get Max Invoice Id");
    await makeGetRequest("invoice/getmaxid", "")
      .then((response) => {
        if (response.data.data !== undefined) {
          console.log("Max Id ", response.data.data.rows[0].maxid);
          setInvoiceNo(response.data.data.rows[0].maxid + 1);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }
  // For Append
  const { useState } = React;
  const AddedElement = () => (
    <div className="addedAppendLine" id="deleteId">
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <input className="inputSt" placeholder="Banquet Hall" />
        </Grid>
        <Grid item xs={12} md={4}>
          <div className="inputWithICon">
            <CurrencyRupeeIcon />
            <input className="inputSt" placeholder="3500" />
          </div>
        </Grid>
      </Grid>
      <Button className="minusBtn" onClick={deleteField}>
        <RemoveIcon />
      </Button>
    </div>
  );
  const [count, setCount2] = useState(0);
  // End

  const addAminitiesClick = () => {
    var element = document.getElementById("addAminitiesId");
    element.classList.add("aminitiesMainAdd");
  };
  useEffect(() => {
    getMaxInvoiceId();
    OwnerListing();
    MaintenenceListing();

    var total = 0;
    for (var j = 0; j < maintenenceList.length; j++) {
      maintenenceIdList[j] = maintenenceList[j].maintenence_id;
      console.log("Before total ", total);
      total = total + maintenenceList[j].amount;
      console.log("After total ", total);
    }

    setSubTotal(total);
    setCgstAmt((total * cgst) / 100);
    setSgstAmt((total * sgst) / 100);
    setTotalPayable(total - advanceReceived + cgstAmt + sgstAmt);
    console.log("Subtotal ", subTotal);
  }, [q]);
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Create Invoice</h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Formik
              enableReinitialize
              initialValues={formikInitials}
              validationSchema={Validation_Schema}
              onSubmit={saveInvoice}
            >
              {({
                values,
                handleChange,
                errors,
                setFieldTouched,
                touched,
                isValid,
                handleSubmit,
              }) => (
                <Form>
                  <div className="invoiceMain">
                    <div className="invoicePaidUnpaidTabMain sendInvoiceTabMain">
                      <Box sx={{ width: "100%" }}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                          <Tabs
                            value={value2}
                            onChange={handleChange2}
                            aria-label="basic tabs example"
                          >
                            <Tab
                              label="Miscellaneous Invoices"
                              {...a11yProps(0)}
                            />
                            <Tab
                              label="Monthly Maintenance Invoices"
                              {...a11yProps(1)}
                            />
                          </Tabs>
                        </Box>
                        <TabPanel value={value2} index={0}>
                          <div className="invoiceInnerMain">
                            <Grid container spacing={3}>
                              <Grid item xs={12} md={4}>
                                <input
                                  className="inputSt"
                                  placeholder="Search by Name"
                                  onChangeCapture={(e) => setQ(e.target.value)}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <select
                                  className="inputSt"
                                  value={selectedOwner}
                                  onChange={handlechangeOwner}
                                  onBlur={() =>
                                    setFieldTouched("selectedOwner")
                                  }
                                  // onChangeCapture={(e) => setSelectedOwner(e.target.value)}
                                >
                                  <option>Select Owner</option>
                                  {ownersList.map((option) => (
                                    <option
                                      key={option.resident_id}
                                      value={option.resident_id}
                                      data-isd={
                                        option.user_obj.first_name +
                                        " " +
                                        option.user_obj.last_name
                                      }
                                    >
                                      {option.user_obj.first_name +
                                        " " +
                                        option.user_obj.last_name}
                                    </option>
                                  ))}
                                </select>
                                {errors.selectedOwner &&
                                touched.selectedOwner ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {errors.selectedOwner}
                                  </div>
                                ) : null}
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <select
                                  className="inputSt"
                                  value={selectedApartment}
                                  onChange={handlechangeApartment}
                                >
                                  <option>Select Apartment</option>
                                  {apartmentList.map((option) => (
                                    <option
                                      key={option.apartment_id}
                                      value={option.apartment_id}
                                      data-isd={option.uniq_apt_name}
                                    >
                                      {option.uniq_apt_name}
                                    </option>
                                  ))}
                                </select>
                              </Grid>
                            </Grid>
                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <h2 className="invoiceSubHeading">
                                  Create Invoice
                                </h2>
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">Invoice #</label>
                                <input
                                  className="inputSt"
                                  placeholder="267345"
                                  value={invoiceNo}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">
                                  Invoice Date
                                </label>
                                <div className="dateTimeMain">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack className="inputSt">
                                      <DesktopDatePicker
                                        inputFormat="MM/DD/YYYY"
                                        value={invoice_date}
                                        onChange={handleInvoiceDate}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>
                                {/* <input type="date" className="inputSt" value={values.invoice_date} onChange={handleInvoiceDate} /> */}
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">Due Date</label>
                                <div className="dateTimeMain">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack className="inputSt">
                                      <DesktopDatePicker
                                        inputFormat="MM/DD/YYYY"
                                        value={due_date}
                                        onChange={handleDueDate}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </div>
                                {/* <input type="date" className="inputSt" value={values.due_date} onChange={handleDueDate} /> */}
                              </Grid>
                              <Grid item xs={12} md={12}>
                                <input
                                  className="inputSt"
                                  placeholder="Subject"
                                  value={values.subject}
                                  onChange={handleChange("subject")}
                                  onBlur={() => setFieldTouched("subject")}
                                  onChangeCapture={(e) =>
                                    setSubject(e.target.value)
                                  }
                                />
                                {errors.subject && touched.subject ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {errors.subject}
                                  </div>
                                ) : null}
                                <Grid item xs={12} md={12}></Grid>
                              </Grid>
                            </Grid>

                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <h2 className="invoiceSubHeading">BIll to</h2>
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid item xs={12} md={4}>
                                <input
                                  type="text"
                                  className="inputSt"
                                  placeholder="Jarome Bell"
                                  disabled
                                  value={billto}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <input
                                  className="inputSt"
                                  placeholder="WIng-B"
                                  disabled
                                  value={wing}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <input
                                  className="inputSt"
                                  placeholder="Flat No. 204"
                                  disabled
                                  value={apartmentNo}
                                />
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <div className="inputWithICon">
                                  <LocalPhoneIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="9823898485"
                                    disabled
                                    value={contactNo}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <div className="inputWithICon">
                                  <MailOutlineIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="sample@gmail.com"
                                    disabled
                                    value={emailId}
                                  />
                                </div>
                              </Grid>
                            </Grid>

                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <h2 className="invoiceSubHeading">
                                  Maintenance Details
                                </h2>
                              </Grid>
                            </Grid>
                            {maintenenceList.map((option) => (
                              <Grid
                                container
                                spacing={3}
                                className="containerSpace"
                              >
                                <Grid item xs={12} md={7}>
                                  <input
                                    className="inputSt"
                                    value={option.maintenence_type}
                                  />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                  <div className="inputWithICon">
                                    <CurrencyRupeeIcon />
                                    <input
                                      className="inputSt"
                                      value={option.amount}
                                    />
                                  </div>
                                </Grid>
                              </Grid>
                            ))}
                            <div
                              className="addAminitiesMain"
                              id="addAminitiesId"
                            >
                              <Grid container>
                                <Grid item xs={12} md={12}>
                                  <Button
                                    className="addAminitiesBt"
                                    onClick={addAminitiesClick}
                                  >
                                    <AddIcon /> Add Amenities
                                  </Button>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  <div className="showingAminities">
                                    <Grid container>
                                      <Grid item xs={12} md={12}>
                                        <h2 className="invoiceSubHeading">
                                          Amenities Details
                                        </h2>
                                      </Grid>
                                    </Grid>

                                    {/*For Append */}
                                    {[...Array(count)].map((_, i) => (
                                      <AddedElement key={i} />
                                    ))}
                                    {/* End */}

                                    <div className="appendLine">
                                      <Grid container spacing={3}>
                                        <Grid item xs={12} md={8}>
                                          <input
                                            className="inputSt"
                                            placeholder="Banquet Hall"
                                          />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                          <div className="inputWithICon">
                                            <CurrencyRupeeIcon />
                                            <input
                                              className="inputSt"
                                              placeholder="3500"
                                            />
                                          </div>
                                        </Grid>
                                      </Grid>
                                      <Button
                                        className="plusBtn"
                                        onClick={() => setCount2(count + 1)}
                                      >
                                        <AddIcon />
                                      </Button>
                                    </div>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>

                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <h2 className="invoiceSubHeading">
                                  Calculate Invoice
                                </h2>
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid item xs={12} md={12}>
                                <input
                                  className="inputSt"
                                  placeholder="Notes"
                                  value={values.note}
                                  onChange={handleChange("note")}
                                  onBlur={() => setFieldTouched("note")}
                                  onChangeCapture={(e) =>
                                    setNote(e.target.value)
                                  }
                                />
                                {errors.note && touched.note ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {errors.note}
                                  </div>
                                ) : null}
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">Sub total</label>
                                <div className="inputWithICon">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="7000"
                                    value={subTotal}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={12} md={4}>
                                <label className="tabsLabel">
                                  Advance Recived
                                </label>
                                <div className="inputWithICon">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="3000"
                                    value={advanceReceived}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={12} md={2}>
                                <label className="tabsLabel">CGST</label>
                                <div className="inputWithICon">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="CGST"
                                    value={cgstAmt}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={12} md={2}>
                                <label className="tabsLabel">SGST</label>
                                <div className="inputWithICon">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="SGST"
                                    value={sgstAmt}
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={12} md={12}>
                                <label className="tabsLabel">
                                  Total Payable
                                </label>
                                <div className="inputWithICon">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt"
                                    placeholder="4000"
                                    value={totalPayable}
                                  />
                                </div>
                              </Grid>
                            </Grid>

                            <Grid container>
                              <Grid
                                item
                                xs={12}
                                md={12}
                                className="previewBtOuter"
                              >
                                {/* <Button
                                  className="addBt SavaeInvoiceBtn"
                                  onClick={() => saveInvoice()}
                                >
                                  Save Invoice
                                </Button> */}
                                <Button
                                  className="addBt PreviewBtn"
                                  onClick={() => navigate("/InvoicePreview")}
                                >
                                  Preview
                                </Button>
                              </Grid>
                            </Grid>
                          </div>
                        </TabPanel>
                        <TabPanel value={value2} index={1}>
                          <div className="invoiceInnerMain">
                            Tab Two Content Here...
                          </div>
                        </TabPanel>
                      </Box>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default SendInvoice;
